class saHeader {

    constructor(options) {
        const that = this;

        // DOM
        that.$wrapper = options["$wrapper"];
        that.$header_overlay = $.sa.$document.find('.js-header-menu-overlay');
        that.$header_menu_dd = that.$wrapper.find('.js-header-menu-dropdown');

        // CONST
        that.class = {
            is_active: 'is-active'
        };
        that.login_modal_title = options['login_modal_title'];
        that.login_modal_body = options['login_modal_body'];
        that.templates = options['templates'];

        // DYNAMIC VARS
        that.content_search = that.initContentSearch();
        that.locale_switch_menu = that.initLocaleSwitchMenu();

        // INIT
        that.init();
    };

    init() {
        const that = this;

        //
        that.initNotificationCenterScrollbar();
        //
        that.headerMenuHandlers();
        //
        that.initMenuDrawer();
        //
        that.initNotificationDrawer();
        //
        that.initAccountMenuDrawer();
    };

    //
    // Notification center
    //
    initNotificationCenterScrollbar() {
        var that = this,
            $notification_center_scroll = that.$wrapper.find('.js-notification-center-scroll');

        $.uiScrollbar($notification_center_scroll);
    }

    //
    // Header menu
    //
    headerMenuHandlers() {
        var that = this,
            $header_menu_buttons = that.$wrapper.find('.js-header-menu-button'),
            $header_menu_close = that.$wrapper.find('.js-header-menu-close');

        $header_menu_buttons.on('click', function (e) {
            e.preventDefault();

            var $button = $(this),
                $menu_wrapper = $button.parent('.js-header-menu-wrapper'),
                current_menu_is_active = $menu_wrapper.hasClass(that.class.is_active);

            that.__headerMenuHideAll();

            if (!current_menu_is_active) {
                that.__headerMenuShow($menu_wrapper);
            }
        });

        $header_menu_close.on('click', function (e) {
            e.preventDefault();

            that.__headerMenuHideAll();
        });

        that.$header_overlay.on('click', function (e) {
            e.preventDefault();

            that.__headerMenuHideAll();
        });

        that.$header_menu_dd.on('click', 'a', function (e) {
            that.__headerMenuHideAll();
        });

        $.sa.$document.keyup(function (e) {
            var $active_menu_wrapper = that.$wrapper.find('.js-header-menu-wrapper.' + that.class.is_active);
            if (e.key === 'Escape' && $active_menu_wrapper.length) {
                that.__headerMenuHideAll();
            }
        });

        $.sa.$document.on('click', function (e) {
            if (!$(e.target).parents('.js-header-nav-menu').length) {
                that.__headerMenuHideAll();
            }
        });
    };

    __headerMenuShow($menu_wrapper) {
        var that = this;

        $menu_wrapper.addClass(that.class.is_active);
        that.$header_overlay.addClass(that.class.is_active);
    }

    __headerMenuHideAll() {
        var that = this,
            $menu_wrappers = that.$wrapper.find('.js-header-menu-wrapper');

        $menu_wrappers.removeClass(that.class.is_active);
        that.$header_overlay.removeClass(that.class.is_active);
    };

    //
    // Language drawer for non desktop devices
    //
    initLocaleSwitchMenu() {
        var that = this,
            $button = that.$wrapper.find('.js-locale-switch-button');

        $button.on('click', function (e) {
            e.preventDefault();
            if (!$.sa.is_desktop()) {
                openDrawer();
            }
        });

        return {
            openDrawer
        }

        function openDrawer() {
            const $drawer_content = that.$wrapper.find('.js-drawer-locale-switch-content').clone(),
                  $drawer_header = $drawer_content.find('.js-drawer-locale-switch-header').html();

            $drawer_content.find('.js-drawer-locale-switch-header').remove();

            $.uiDrawerBottom({
                header_contrast: true,
                header: $drawer_header,
                content: $drawer_content,
                onBgClick: function (uiDrawerBottom) {
                    uiDrawerBottom.close();
                }
            });
        }
    };

    initMenuDrawer() {
        var that = this,
            $button = that.$wrapper.find('.js-menu'),
            $menu_tab_titles = that.$wrapper.find('.js-build-accordion'),
            accordion_content = [],
            drawer_content = [];

        $.each($menu_tab_titles, function () {
            var $tab_title = $(this),
                $tab_content = that.$wrapper.find('.js-tab-content[data-tab-id="' + $tab_title.data('tab-for') + '"]'),
                $tab_link = null,
                $tab_link_icon_class = null,
                $tab_target = null;

            if ($tab_title.attr('href')) {
                $tab_link = $tab_title.attr('href');

                if ($tab_title.attr('target')) {
                    $tab_target = $tab_title.attr('target');
                }
                if ($tab_title.data('link-icon')) {
                    $tab_link_icon_class = $tab_title.data('link-icon');
                }
            }

            accordion_content.push({
                title: $tab_title.text(),
                link: $tab_link,
                link_target: $tab_target,
                link_icon_class: $tab_link_icon_class,
                content: $tab_content.html(),
                description: $tab_title.data('description')
            });
        });

        var $accordion_content = $.uiAccordionBuilder({
            data: accordion_content,
            wrapper_class: 'header-drawer-accordion clear is-one-active'
        });

        drawer_content.push($accordion_content);
        drawer_content.push(that.templates['content_footer']);

        $button.on('click', function (e) {
            e.preventDefault();

            if (!$.sa.is_desktop()) {
                $.uiDrawer({
                    position: 'right',
                    mobile_fullscreen: true,
                    header_contrast: true,
                    custom_class: 'header-mobile-menu-drawer',
                    header_description: that.templates['header_description'],
                    content: drawer_content,
                    onOpen: function($drawer) {
                        $drawer.on('click', '.js-locale-switch-button', function() {
                            that.locale_switch_menu.openDrawer();
                        });
                        $drawer.on('click', '.js-content-search-input', function() {
                            that.content_search.openDrawer();
                        });
                    }
                });
            }
        });
    };

    initNotificationDrawer() {
        var that = this,
            $button = that.$wrapper.find('.js-notification'),
            $header = that.$wrapper.find('.js-notification-header').html(),
            $content = that.$wrapper.find('.js-notification-content').html(),
            content_class = that.$wrapper.find('.js-notification-content').data('drawer-class'),
            $drawer_content = [$header, $content];


        $button.on('click', function (e) {
            e.preventDefault();

            if (!$.sa.is_desktop()) {
                $.uiDrawer({
                    position: 'right',
                    mobile_fullscreen: true,
                    custom_class: content_class,
                    content: $drawer_content
                });
            }
        });
    };

    initContentSearch() {
        var that = this,
            $content_search_button = that.$wrapper.find('.js-content-search-button'),
            $content_search_wrapper = that.$wrapper.find('.js-content-search-wrapper'),
            $content_search_input = that.$wrapper.find('.js-content-search-input'),
            $content_search_uiinput = $content_search_input.parents('.input'),
            $content_search_results = that.$wrapper.find('.js-content-search-results-wrapper');

        // Prepare data for Drawer
        var $drawer_content_fixed = $content_search_uiinput.clone(),
            $drawer_content = $content_search_results.clone();

        new ContentSearch({
            $wrapper: $content_search_wrapper,
            scrollbar_is_needed: true,
        });

        $content_search_button.on('click', function (e) {
            e.preventDefault();
            $content_search_input.val('');
            $content_search_results.html('');

            if (!$.sa.is_desktop()) {
                openDrawer();
            } else {
                setTimeout(function () {
                    $content_search_input.focus();
                }, 1);
            }
        });

        return {
            openDrawer
        };

        function openDrawer() {
            return $.uiDrawer({
                position: 'right',
                mobile_fullscreen: true,
                custom_class: 'content-search-drawer',
                content_fixed: $drawer_content_fixed,
                content: $drawer_content,
                header_contrast: $.sa.is_mobile(),
                onOpen: function ($drawer_wrapper, drawer) {
                    $drawer_wrapper.on('click', '.js-content-item', function () {
                        drawer.close();
                    });
                    $drawer_wrapper.find('.js-content-search-input').focus();
                    new ContentSearch({
                        $wrapper: $drawer_wrapper,
                    });
                }
            });
        }
    };

    initAccountMenuDrawer() {
        var that = this,
            $button = that.$wrapper.find('.js-account-menu'),
            $content = that.$wrapper.find('.js-account-menu-content').html(),
            content_class = that.$wrapper.find('.js-account-menu-content').data('drawer-class');

        $button.on('click', function (e) {
            e.preventDefault();

            if (!$.sa.is_desktop()) {
                $.uiDrawer({
                    position: 'right',
                    mobile_fullscreen: true,
                    custom_class: content_class,
                    content: $content
                });
            }

        });
    };
}
